import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    position: relative;
    height: 40px;
    cursor: pointer;
    width: 100%;
}
`;

export const IconArea = styled.span`
    font-weight: 400;
    top: 60%;
    transform: translateY(-60%);
    position: absolute;
}
`;

export const Label = styled.span`
    margin-left: 30px;
    font-weight: 400;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
}
`;
